import React__default from 'react';
import { ModalLoadingWrapper } from '../styles.js';
import { Spinner } from '../../Spinner/index.js';

function DialogLoading(props) {
    return (React__default.createElement(ModalLoadingWrapper, { "data-testid": props['data-testid'], "data-trackid": props['data-trackid'] },
        React__default.createElement(Spinner, { size: "L", variant: "secondary" })));
}

export { DialogLoading };
